<template>
    <v-dialog v-model="dialog.show" persistent max-width="460">
        <v-card tile flat>
            <v-card-title class="headline">{{getLabel(dialog.action)}} esemény elfogadása</v-card-title>
            <v-card-text>
                Biztosan elfogadja az eseményt?
                <br /><br />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn depressed tile @click="close">Mégsem</v-btn>
                <v-btn depressed tile color="green" @click="save">Mentés</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import CONSTANTS from "@/constants";
    import eventBus from '@/eventBus';

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: 'ApproveDialog',
        props: {
            getLabel: Function,
        },
        data: function () {
            return {
                dialog: {
                    show: false,
                    UUID: null,
                    action: null
                }
            }
        },
        created() {
            let self = this;

            this.$busOn(CONSTANTS.DMR.APPROVE_MODAL, function (item) {
                self.dialog = {
                    show: true,
                    UUID: item.UUID,
                    action: item.action
                }
            });
        },
        methods: {
            close: function () {
                this.dialog = {
                    show: false,
                    UUID: null,
                    action: null
                }
            },
            save: function () {
                let self = this;

                eventBus.$emit(CONSTANTS.DMR.APPROVE, {
                    UUID: self.dialog.UUID
                });

                self.close();
            },
        }
    }
</script>
